<template>
    <div>
        <el-select
            v-if="mode == 'edit'"
            ref="select"
            v-model="tmpValue"
            filterable
            :multiple="multiple"
            remote
            :placeholder="placeholder ? placeholder : $t.__('common.actions.search')"
            :remoteMethod="remoteMethod"
            :loading="loading"
            :loadingText="$t.__('common.labels.loading')"
            :multipleLimit="limit"
            :size="size"
            :popperClass="popperClass"
            class="wp-10"
            :popperOptions="{
                strategy: 'fixed',
            }"
            @change="update"
            @focus="focusingSearch"
        >
            <el-option
                v-for="(item, index) in options"
                :key="index"
                :label="item.name"
                :value="parseInt(item.id)"
            >
            </el-option>
            <template v-if="enableAddAction">
                <el-option
                    v-if="hasNoOption"
                    :label="noDataLabel"
                    class="cauto"
                    :value="0"
                    disabled
                ></el-option>
                <el-option
                    label=""
                    :class="{ 'bt-1': options.length }"
                    class="p-0 hover-white-bkg white-bkg"
                    :value="0"
                >
                    <slot name="addAction"></slot>
                </el-option>
            </template>
        </el-select>
        <p v-else>
            <person-list :list="selectedItems" size="small" :relatedData="relatedData" />
        </p>
    </div>
</template>

<script>
import PersonList from 'vcomponents/utilities/PersonList.vue';

export default {
    components: {
        'person-list': PersonList,
    },
    props: {
        mode: {
            type: String,
        },
        modelValue: {
            type: [Number, Array, Object, Boolean],
            required: false,
            default: false,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        preset: {
            type: Array,
            required: false,
            default: () => [],
        },
        limit: {
            type: Number,
            required: false,
            default: 0,
        },
        route: {
            type: String,
            required: true,
        },
        allowedType: {
            type: Array,
            required: false,
            default: () => [],
        },
        size: {
            type: String,
            required: false,
            default: '',
        },
        queryParameters: {
            type: Object,
            required: false,
            default: () => {},
        },
        defaultOptions: {
            type: Array,
            required: false,
            default: () => [],
        },
        searchOnFocus: {
            type: Boolean,
            required: false,
            default: false,
        },
        relatedData: {
            type: [Object, Boolean],
            required: false,
            default: false,
        },
        multiple: {
            type: Boolean,
            required: false,
            default: true,
        },
        enableAddAction: {
            type: Boolean,
            required: false,
            default: false,
        },
        noDataText: {
            type: String,
            required: false,
        },
        popperClass: {
            type: String,
            required: false,
            default: '',
        },
    },
    emits: ['update:modelValue', 'emptied', 'change'],
    data() {
        return {
            tmpValue: [],
            options: [],
            loading: false,
        };
    },
    computed: {
        selectedItems() {
            return this.options.filter((value) => this.tmpValue.includes(value.id));
        },
        concatenatedValues() {
            return this.selectedItems.map((item) => item.name).join(', ');
        },
        hasNoOption() {
            return !(Object.keys(this.options).length || this.options.length);
        },
        noDataLabel() {
            return this.noDataText ? this.noDataText : this.$l10n.__('Aucun résultat trouvé');
        },
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.tmpValue = [];
            if (this.preset.length > 0) {
                _.map(
                    this.preset,
                    function (val) {
                        val.id = parseInt(val.id);
                        if (!val.name && val.fullName && val.fullName != '') {
                            val.name = val.fullName;
                        }
                        this.options.push(val);
                    }.bind(this),
                );
            }

            if (Array.isArray(this.modelValue) && this.modelValue.length > 0) {
                _.map(this.modelValue, function (val) {
                    this.tmpValue.push(val);
                });
            } else {
                if (this.modelValue == 0) {
                    this.tmpValue = [];
                } else if (this.multiple) {
                    this.tmpValue.push(this.modelValue);
                } else {
                    this.tmpValue = this.modelValue;
                }
            }

            if (this.defaultOptions.length > 0) {
                this.options = this.defaultOptions;
            }
        },
        reset() {
            this.options = [];
            this.tmpValue = [];
        },
        update(newValue) {
            if (newValue.length == 0) {
                if (this.limit == 1) {
                    this.$emit('update:modelValue', 0);
                } else {
                    this.$emit('update:modelValue', []);
                }
                this.$emit('emptied');
            } else {
                if (this.limit == 1 && newValue[0]) {
                    this.$emit('update:modelValue', newValue[0]);
                    this.$emit('change', newValue[0]);
                } else {
                    this.$emit('update:modelValue', newValue);
                }
            }
        },
        remoteMethod: _.debounce(function (query) {
            this.options = [];
            if (this.route != '') {
                this.loading = true;
                // ajax method to get third with type & name
                this.$ajax.get(
                    this.route,
                    { ...{ q: query, types: this.allowedType }, ...this.queryParameters },
                    (response) => {
                        const concat = [...this.defaultOptions, ...response];
                        this.options = concat.reduce((unique, o) => {
                            if (!unique.some((obj) => obj.id === o.id)) {
                                unique.push(o);
                            }
                            return unique;
                        }, []);

                        if (!this.options.length && !query.length) {
                            this.init();
                        }
                        this.loading = false;
                    },
                    (error) => {
                        this.close();
                        Push.error(this.$l10n.__('Problème lors de la récupération des données'));
                    },
                );
            } else {
                this.options = [];
            }
        }, 100),
        focusingSearch() {
            if (this.searchOnFocus) {
                this.remoteMethod('');
            } else {
                return false;
            }
        },
        blur() {
            this.$refs.select.blur();
        },
    },
};
</script>

<style lang="scss">
.cauto {
    cursor: auto !important;
}
</style>
